import { colors, mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledDropdown = styled.div`
  min-width: 15rem;
`

export const Variants = styled.div`
  max-height: 400px;
  ${mixin.scrollableY};
  ${mixin.customScrollbar()};
`

export const Variant = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  padding: 0.5rem 0.75rem;
  word-break: break-word;
  cursor: pointer;

  font-weight: ${({ isSelected }) => (isSelected ? "bold" : "normal")};

  :hover {
    background-color: ${colors.backgroundLight};
  }
`
